import { useCallback } from "react";

export const useModalResize = (modalRef: React.RefObject<HTMLDivElement>) => {
	
	const handleResizeMouseDown = useCallback((e: React.MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();

		const modal = modalRef.current;
		if (!modal) return;

		const startX = e.clientX;
		const startY = e.clientY;
		const startWidth = modal.offsetWidth;
		const startHeight = modal.offsetHeight;

		const handleMouseMove = (moveEvent: MouseEvent) => {
			const deltaX = moveEvent.clientX - startX;
			const deltaY = moveEvent.clientY - startY;

			modal.style.width = `${Math.max(200, startWidth + deltaX)}px`;
			modal.style.height = `${Math.max(100, startHeight + deltaY)}px`;
			modal.style.maxHeight = 'none';
		};

		const handleMouseUp = () => {
			document.removeEventListener('mousemove', handleMouseMove);
			document.removeEventListener('mouseup', handleMouseUp);
		};

		document.addEventListener('mousemove', handleMouseMove);
		document.addEventListener('mouseup', handleMouseUp);
	}, []);

	return { handleResizeMouseDown };
};
